import React from 'react';

export interface EmptyStateProps {
  icon: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
  note?: string;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  actions,
  note,
  className = '',
}: EmptyStateProps) {
  return (
    <div className={`empty-state ${className}`}>
      <div className="empty-icon">
        <i className={icon}></i>
      </div>
      <h3>{title}</h3>
      {description && <p>{description}</p>}
      {actions && <div className="empty-state-actions">{actions}</div>}
      {note && <p className="empty-note">{note}</p>}
    </div>
  );
}
